import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { modulePermissionsApi, type PermLevel } from '@/apps/admin/lib/module-permissions-api';

const RANK: Record<PermLevel, number> = { none: 0, view: 1, edit: 2 };
export const MODULE_PERMS_KEY = ['my-module-permissions'];

export function useModulePermissions() {
  const q = useQuery({
    queryKey: MODULE_PERMS_KEY,
    queryFn: modulePermissionsApi.myPermissions,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
  const levels = useMemo(() => {
    const m: Record<string, PermLevel> = {};
    (q.data ?? []).forEach(p => { m[p.module_key] = p.level; });
    return m;
  }, [q.data]);
  const levelOf = useCallback((key: string): PermLevel => levels[key] ?? 'none', [levels]);
  const canAccess = useCallback((key: string, need: 'view' | 'edit' = 'view') =>
    RANK[levelOf(key)] >= RANK[need], [levelOf]);
  return { ...q, permissions: q.data ?? [], levelOf, canAccess };
}
